/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Edit_BoardInputs */

const cs_pipelines_edit_board = /** @type {(inputs: Pipelines_Edit_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit pipeline`)
};

const en_pipelines_edit_board = /** @type {(inputs: Pipelines_Edit_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit pipeline`)
};

/**
* | output |
* | --- |
* | "Edit pipeline" |
*
* @param {Pipelines_Edit_BoardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_edit_board = /** @type {((inputs?: Pipelines_Edit_BoardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Edit_BoardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_edit_board(inputs)
	return cs_pipelines_edit_board(inputs)
});